import { domReady } from '@roots/sage/client';
import axios from 'axios';
import Qs from 'qs';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
import 'lazysizes';
import collapse from '@alpinejs/collapse';
import './partials/scrollSlider';
import './partials/downloadModal';

Alpine.plugin(collapse);

window.Splide = Splide;
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.Qs = Qs;
window.Alpine = Alpine;

/**
 * app.main
 */
const main = async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  // application code
  console.log(`hello app`);
};

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
Alpine.start();
domReady(main);
import.meta.webpackHot?.accept(main); // eslint-disable-line
